<rt-button
  class="action new"
  variant="plain"
  size="medium"
  layout-full-width
  (click)="newThread.emit()"
>
  <rt-icon name="edit-square" class="action-icon" />
  <span class="action-label">
    {{ 'tlc.tellent_assistant.thread_drawer.new_conversation_label' | translate }}
  </span>
</rt-button>

<p class="label">
  {{ 'tlc.tellent_assistant.thread_drawer.history_heading' | translate }}
</p>
<ul>
  @for (thread of threads(); track thread.id) {
    <li [class.has-menu-open]="menuOpenForThread() === thread.id">
      <rt-button
        variant="plain"
        size="medium"
        layout-full-width
        [class.active]="thread.id === activeId()"
        (click)="selectThread.emit(thread.id)"
      >
        <span class="thread-title">{{ thread.title || defaultTitle }}</span>

        <span class="trailing">
          @if (thread.pinned) {
            <rt-icon name="pin" />
          }
          <rt-icon-button
            #kebabOrigin="rtOverlayOrigin"
            rt-overlay-origin
            iconName="more-vert"
            size="small"
            variant="plain"
            class="menu"
            [active]="menuOpenForThread() === thread.id"
            data-testid="thread-menu"
            (click)="onKebabClick(thread.id, kebabOrigin, $event)"
          />
        </span>
      </rt-button>

      <ng-template
        rt-connected-overlay
        [origin]="kebabOrigin"
        [open]="menuOpenForThread() === thread.id"
        [positions]="menuPositions"
        [offsetY]="4"
        [width]="180"
        hasBackdrop
        withOverlayLevel
        (backdropClick)="menuOpenForThread.set(null)"
      >
        <rt-dropdown>
          <rt-dropdown-item (click)="onPinClick(thread)">
            <rt-icon [name]="thread.pinned ? 'pin-off' : 'pin'" prefix />{{
              (thread.pinned
                ? 'tlc.tellent_assistant.header.menu_unpin'
                : 'tlc.tellent_assistant.header.menu_pin'
              ) | translate
            }}
          </rt-dropdown-item>
          <rt-divider />
          <rt-dropdown-item (click)="onRemoveClick(thread.id)">
            <rt-icon name="delete" prefix />{{
              'tlc.tellent_assistant.header.menu_remove' | translate
            }}
          </rt-dropdown-item>
        </rt-dropdown>
      </ng-template>
    </li>
  }
</ul>

<footer class="bottom">
  <rt-button
    class="action"
    variant="plain"
    size="medium"
    layout-full-width
    (click)="helpCenter.emit()"
  >
    <rt-icon name="help-outline" class="action-icon" />
    <span class="action-label">
      {{ 'tlc.tellent_assistant.thread_drawer.help_center_label' | translate }}
    </span>
    <rt-icon name="open-in-new" class="external" />
  </rt-button>
  <rt-button
    class="action"
    variant="plain"
    size="medium"
    layout-full-width
    (click)="intelligenceSettings.emit()"
  >
    <rt-icon name="nav-settings-outline" class="action-icon" />
    <span class="action-label">
      {{ 'tlc.tellent_assistant.thread_drawer.intelligence_settings_label' | translate }}
    </span>
    <rt-icon name="open-in-new" class="external" />
  </rt-button>
</footer>
